var _defs, _rect, _rect2, _rect3, _rect4, _g, _rect5, _g2, _rect6, _rect7, _g3, _rect8, _rect9, _rect10, _rect11, _g4, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGameRulePipe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117.04 168.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .clsa-1{fill:none;}.clsa-2{fill:#924686;}.clsa-3{fill:#9e5b93;}.clsa-4{fill:#6e2f64;}.clsa-5{clip-path:url(#clip-path);}.clsa-6{fill:#853178;}.clsa-7{fill:#c094b9;}.clsa-8{fill:#cdabc8;}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "clsa-1",
    width: 117.04,
    height: 168.56
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-2",
    x: 51.61,
    y: 73.6,
    width: 2.72,
    height: 4.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-3",
    x: 48.51,
    y: 78.08,
    width: 8.92,
    height: 2.76
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-4",
    x: 108.46,
    width: 7.31,
    height: 81.18
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-4",
    x: 69.84,
    y: 80.83,
    width: 38.73,
    height: 7.31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clsa-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsa-6",
    d: "M107.14,89.36h.13A9.77,9.77,0,0,0,117,79.59h-9.9Z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-4",
    x: 64.99,
    y: 87.38,
    width: 7.31,
    height: 81.18
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "clsa-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsa-6",
    d: "M73.63,79.2h-.14A9.78,9.78,0,0,0,63.72,89h9.91Z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-2",
    y: 65.92,
    width: 81.18,
    height: 7.31
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-2",
    x: 80.83,
    y: 73.12,
    width: 7.31,
    height: 38.73
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "clsa-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsa-3",
    d: "M89.36,74.55s0-.09,0-.13a9.77,9.77,0,0,0-9.78-9.77v9.9Z"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-7",
    x: 32.95,
    y: 40.66,
    width: 7.31,
    height: 81.18
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-3",
    x: 49.88,
    y: 63.99,
    width: 6.22,
    height: 11.17
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-3",
    x: 17.81,
    y: 63.99,
    width: 6.22,
    height: 11.17
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-7",
    x: 26.9,
    y: 83.63,
    width: 6.15,
    height: 3.42
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "clsa-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsa-8",
    d: "M28.25,81.05a2.14,2.14,0,1,1-2.13-2.13,2.14,2.14,0,0,1,2.13,2.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsa-8",
    d: "M28.25,85.38a2.14,2.14,0,1,1-2.13-2.14,2.13,2.13,0,0,1,2.13,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsa-8",
    d: "M28.25,89.65a2.14,2.14,0,1,1-2.13-2.14,2.14,2.14,0,0,1,2.13,2.14"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "clsa-8",
    x: 31.13,
    y: 81.35,
    width: 11.06,
    height: 8.06
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameRulePipe);
export default __webpack_public_path__ + "static/media/game-rule-pipe.e30772fa.svg";
export { ForwardRef as ReactComponent };